import LogRocket from 'logrocket';
import template from './profileInfo.html';


export default {
  name: 'proInfoComponent',
  template,
  controller: ProfileInfoController,
  controllerAs: 'ProInfoCtrl',
  bindings: {
    // TODO: Don't really need this with appConfig.user
    user: '<'
  }
};

/* @ngInject */
function ProfileInfoController(
  $scope,
  growl,
  appConfig,
  ProfileService,
  UsersService,
) {
  const vm = this;

  vm.editing = false;
  vm.settings = appConfig.user.settings;
  vm.userClone = {};

  vm.$onInit = $onInit;
  vm.$onChanges = onChanges;
  vm.resetPassword = resetPassword;
  vm.saveProfile = saveProfile;
  vm.cancel = cancel;


  $scope.$watch(() => vm.settings, (settings, oldSettings) => {
    if (!settings || _.isEqual(settings, oldSettings)) {
      return;
    }

    // ? This growl is meant to mitigate the delay in settings taking effect
    growl.success(
      'Some settings may require a refresh before taking effect',
      { title: 'Your settings have been updated' }
    );
    UsersService.saveUser(appConfig.user);
  }, true);


  function $onInit() {
    _.defaults(vm.settings, {
      groupedBoardsView: false,
      qf_dashboards: true,
      qf_equipment: true,
      qf_groups: true,
      qf_organizations: true,
      qf_sites: true,
      qf_users: false, // TODO: Re-enable in QF service
    });
    vm.qfs = [
      { kind: 'dashboards', can: true },
      { kind: 'equipment', can: vm.user.partner },
      { kind: 'groups', can: vm.user.admin },
      { kind: 'organizations', can: vm.user.partner },
      { kind: 'sites', can: vm.user.admin },
    ];
  }


  function onChanges({ user }) {
    if (_.size(user.currentValue)) {
      _.assign(vm.userClone, user.currentValue);
    }
  }

  function resetPassword() {
    let growlMessage = growl.info('Sending password reset email...');
    ProfileService.resetPassword({ email: vm.user.email })
      .then(() => {
        growlMessage.destroy();
        growlMessage = growl.success('Password reset email sent.');
      })
      .catch((res) => {
        growlMessage.destroy();
        const error = 'Error sending password reset email';
        growlMessage = growl.error(res.error, { title: error });
        LogRocket.track(error);
      });
  }

  function saveProfile() {
    let growlMessage = growl.info('Saving changes to user info...');
    ProfileService.saveProfile(angular.copy(vm.userClone))
      .then(() => {
        growlMessage.destroy();
        growlMessage = growl.success('Changes saved.');
        vm.editing = false;
        _.merge(vm.user, vm.userClone);
        appConfig.user = vm.user;
      })
      .catch((res) => {
        growlMessage.destroy();
        const error = 'Error saving changes...';
        growlMessage = growl.error(res.error, { title: error });
        LogRocket.track(error);
      });
  }

  function cancel() {
    vm.userClone = _.merge({}, vm.user);
    vm.editing = false;
  }
}
